export const reportsRoutes = {
    path: 'report',
    name: 'reports',
    alias: '/report',
    meta: { requiresAuth: true, title: 'Dreasyfly - Reports' },
    component: () => import('../views/ReportsLayout.vue'),
    children: [
        {
            path: '',
            name: 'reportsIndex',
            redirect: { name: 'myLedgerView' }
        },
        {
            path: 'ledger',
            name: 'myLedgerView',
            meta: { title: 'Dreasyfly - My Ledger' },
            component: () => import('../views/Ledger.vue')
        },
        {
            path: 'book-history',
            name: 'bookHistoryView',
            meta: { title: 'Dreasyfly - Book History' },
            component: () => import('../views/BookHistory.vue')
        }
    ]
};